import { EUROPE_REGION_ID } from '@/constants/serviceRegion.constants';
import { CountryEntryView } from '@/api/apis/facilities';

export const getIsEuropeanRegion = (regionId?: string) => regionId === EUROPE_REGION_ID;

export const getCountriesFilterByServiceRegion = (
  regionId: string,
  countriesByIso2: Record<string, CountryEntryView>,
) => {
  return Object.values(countriesByIso2)
    .filter((c) => c.serviceRegionId === regionId)
    .map((c) => c.alpha2)
    .join(',');
};
